import * as brandColors from '../../../utils/brand-colors';

export default () => ({
  eventName: {
    fontSize: 14,
    fontWeight: 400,
    marginTop: 0,
    marginBottom: 0,
  },
  eventNameContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  statusContainer: {
    color: '#9e9e9e',
    fontSize: 12,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
  },
  statusName: {
    marginLeft: 4,
    marginRight: 12,
  },
  eventIdField: { color: brandColors.grey[500] },
});
